module.exports = __webpack_public_path__ + "static/media/Partner_1.45c6d681.png";